
import { Directive, inject, input, DOCUMENT } from '@angular/core';

export abstract class NgClickOutsideExcludeToken {
  abstract isExclude(target: any): boolean;
}

@Directive({
  selector: '[clickOutsideExclude]',
  standalone: true,
  providers: [
    {
      provide: NgClickOutsideExcludeToken,
      useExisting: ClickOutsideExcludeDirective,
    },
  ],
})
export class ClickOutsideExcludeDirective {
  /**
   * A comma-separated string of DOM element queries to exclude when clicking outside of the element.
   * For example: `[exclude]="'button,.btn-primary'"`.
   */
  clickOutsideExclude = input('');

  private document: Document = inject(DOCUMENT);

  public excludeCheck(): HTMLElement[] {
    const clickOutsideExclude = this.clickOutsideExclude();
    if (clickOutsideExclude) {
      try {
        const nodes = Array.from(
          this.document.querySelectorAll(clickOutsideExclude)
        ) as Array<HTMLElement>;
        if (nodes) {
          return nodes;
        }
      } catch (err) {
        console.error(
          '[ng-click-outside] Check your exclude selector syntax.',
          err
        );
      }
    }
    return [];
  }

  public isExclude(target: any): boolean {
    const nodesExcluded = this.excludeCheck();
    for (let excludedNode of nodesExcluded) {
      if (excludedNode.contains(target)) {
        return true;
      }
    }

    return false;
  }
}
